// Action types
const LOGOUT = 'LOGOUT';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

// Initial state
const initialState = {
  token: null,
  userId: null,
};

// Reducer
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        userId: action.payload.userId,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

// Action creators
export const logout = () => ({
  type: LOGOUT,
});

export default authReducer;
